<template>
  <div class="data-container">
    <!-- 查询表单 -->
    <form class="query-form" @submit.prevent="handleQuery">
      <div class="form-group">
        <label>渠道：</label>
        <input
          type="text"
          v-model="queryParams.src"
          placeholder="请输入渠道，留空为所有渠道"
          class="form-input"
        >
      </div>

      <div class="form-group">
        <label>广告主：</label>
        <input
          type="text"
          v-model="queryParams.tar"
          placeholder="请输入广告主"
          class="form-input"
        >
      </div>

      <!-- 修改日期选择部分 -->
      <div class="form-group">
        <label>时间范围：</label>
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
        ></el-date-picker>
      </div>

      <button type="submit" class="query-button">
        {{ loading ? '查询中...' : '查询' }}
      </button>
    </form>

    <!-- 数据表格 -->
    <div class="table-wrapper" v-if="tableData.length">
      <table class="data-table">
        <thead>
          <tr>
            <th>日期</th>
            <th>渠道</th>
            <th>广告主</th>
            <th>点击数</th>
            <template v-for="col in validColumns">
              <th :key="`header_${col}`">返回码{{ col }}</th>
              <th :key="`callback_header_${col}`">返回码{{ col }}回调</th>
            </template>
          </tr>
        </thead>

        <tbody>
          <tr v-for="(item, index) in tableData" :key="`row_${index}`">
            <td>{{ item.day }}</td>
            <td>{{ retsrc }}</td>
            <td>{{ item.tar }}</td>
            <td>{{ item.click }}</td>
            <template v-for="col in validColumns">
              <td 
                :key="`transform_${col}_${index}`"
                :class="{ 'highlight': item.transform[col] > 0 }"
              >
                {{ item.transform[col] || 0 }}
              </td>
              <td 
                :key="`calltransform_${col}_${index}`"
                :class="{ 'highlight': item.calltransform[col] > 0 }"
              >
                {{ item.calltransform[col] || 0 }}
              </td>
            </template>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-else class="empty-tip">
      {{ loading ? '数据加载中...' : '暂无数据' }}
    </div>
  </div>
</template>

<script>
import {GetDataFlow} from '../api/index'

import dayjs from 'dayjs'


export default {
  data() {
    return {
      loading: false,
      queryParams: {
        src: '',
        tar: '',
        startDate: '',
        endDate: ''
      },
      retsrc:'',
      tableData: [],
      validColumns: [],
      dateRange: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        },
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            const end = dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')
            const start = dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss')
            picker.$emit('pick', [start, end])
          }
        },
        {
          text: '最近一周',
          onClick(picker) {
            const end = dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')
            const start = dayjs().subtract(7,'day').startOf('day').format('YYYY-MM-DD HH:mm:ss')
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一月',
          onClick(picker) {
            const end = dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')
            const start = dayjs().subtract(1,'month').startOf('day').format('YYYY-MM-DD HH:mm:ss')
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三月',
          onClick(picker) {
            const end = dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')
            const start = dayjs().subtract(3,'month').startOf('day').format('YYYY-MM-DD HH:mm:ss')
            picker.$emit('pick', [start, end])
          }
        }]
      },

    }
  },
  created() {
    this.initDates()
  },
  computed: {
    processedColumns() {

      if(this.tableData == null) return;

      const columns = new Set();
      this.tableData.forEach(item => {
        item.transform.forEach((val, idx) => {
          if (val > 0) columns.add(idx);
        });
      });
      return Array.from(columns).sort((a, b) => a - b);
    }
  },
  methods: {
    initDates() {
      this.dateRange = [
        dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
      ]
    },

    mockFetchData() {
      const params = {
        src: this.queryParams.src,
        tar: this.queryParams.tar,
        startDate: this.dateRange[0],
        endDate: this.dateRange[1]
      }
      return GetDataFlow(params)
    },

    async handleQuery() {

      if(!this.queryParams.tar){
        this.$message.error("请填写查询的渠道")
        return
      }

      if(!this.dateRange || this.dateRange.length < 2){
        this.$message.error("请填写查询的时间段")
        return
      }

      this.loading = true;
      try {
        const response = await this.mockFetchData();

        this.retsrc = !this.queryParams.src ? "所有": this.queryParams.src 
        this.tableData = response.data;
        this.validColumns = this.processedColumns;
      } catch (error) {
        this.$message.error("数据获取失败:"+error)
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>

/* 添加日期选择器样式 */
.el-date-editor.el-input {
  width: 350px;
}
.data-container {
  max-width: 1600px;
  margin: 20px auto;
  padding: 20px;
}

.query-form {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 30px;
}

.form-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.form-input, .form-date {
  padding: 8px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  width: 200px;
}

.query-button {
  padding: 10px 20px;
  background: #409eff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.3s;
}

.query-button:hover {
  background: #66b1ff;
}

.table-wrapper {
  overflow-x: auto;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

.data-table th, .data-table td {
  border: 1px solid #ebeef5;
  padding: 12px;
  text-align: center;
}

.data-table th {
  background: #f5f7fa;
  color: #303133;
}

.data-table tr:hover {
  background-color: #f5f7fa;
}

.highlight {
  color: #67c23a;
  font-weight: bold;
}

.empty-tip {
  text-align: center;
  color: #909399;
  padding: 40px 0;
}
</style>